import React from 'react';
import { CatalogMapCatalogItemViewModel } from '@common/model/catalog/item/map.view';
import { GeoPoint } from '@youhelp-ru/core';
import type { Marker } from '../yh-map';

export const useMapMarkers = (locations: CatalogMapCatalogItemViewModel[]) => {
  const markers = React.useMemo<Marker[] | undefined>(() => {
    return locations
      .map((item) => {
        const { id, location, clientProfile } = item;

        if (!location && clientProfile.location) return;
        return {
          id,
          location: location ? GeoPoint.parse('geo:' + location) : GeoPoint.parse('geo:' + clientProfile.location),
        };
      })
      .filter(Boolean) as NonNullable<Marker[]>;
  }, [locations]);

  return { markers };
};
